import React from 'react';

function TCell(props: any) {
  return <td {...props} />;
}

export default TCell;
